import StoreModuleService from '../../../StoreModuleService';
import { MODULE_NAME } from './const';
import isEmpty from 'lodash/isEmpty';
import api from '@/api';
// import state from './state';
import { SET_INSTALLABLE_VERSIONS, SET_INSTALLABLE_VERSION } from './mutations';
import { getInstallableVersions as getInstallableVersionsGetter, getInstallableVersion as getInstallableVersionGetter } from './getters';
import { getWorkflowData } from '../../../workflows/actions';
import { selectWorkflowId } from '../../../selectedWorkflow/actions';

const buildInstallablesVersionsActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const getInstallableVersions = buildInstallablesVersionsActionObject('getInstallableVersions');
export const fetchInstallableVersions = buildInstallablesVersionsActionObject('fetchInstallableVersions');
export const setInstallableVersions = buildInstallablesVersionsActionObject('setInstallableVersions');
export const getInstallableVersion = buildInstallablesVersionsActionObject('getInstallableVersion');
export const setInstallableVersion = buildInstallablesVersionsActionObject('setInstallableVersion');
export const fetchInstallableVersion = buildInstallablesVersionsActionObject('fetchInstallableVersion');
export const installInstallableVersion = buildInstallablesVersionsActionObject('installInstallableVersion');

const actions = {
	...StoreModuleService.createDefaultActions(),
	[getInstallableVersions.action]({ dispatch, getters }, payload) {
		const forceGet = payload?.forceGet ?? true;
		const { id: installableId } = payload;
		const dataIsMissing = isEmpty(getters[getInstallableVersionsGetter.getter](installableId));
		const needToGet = dataIsMissing || forceGet;
		if (needToGet) {
			dispatch(fetchInstallableVersions.action, { id: installableId });
		}
	},
	async [fetchInstallableVersions.action]({ dispatch }, payload) {
		const { id: installableId } = payload;
		const ret = await api.getInstallableVersions(installableId);
		dispatch(setInstallableVersions.action, {
			data: ret.reduce(
				(installableVersions, installableVersion) => ({ ...installableVersions, [installableVersion.id]: installableVersion }),
				{}
			),
			id: installableId,
		});
	},
	[setInstallableVersions.action]({ commit }, payload) {
		// const { data, id: installableId } = payload;
		commit(SET_INSTALLABLE_VERSIONS, payload);
	},
	[getInstallableVersion.action]({ dispatch, getters }, payload) {
		const forceGet = payload?.forceGet ?? true;
		const { id: installableVersionId, installableId } = payload;
		const dataIsMissing = isEmpty(getters[getInstallableVersionGetter.getter](installableId, installableVersionId));
		const needToGet = dataIsMissing || forceGet;
		if (needToGet) {
			dispatch(fetchInstallableVersion.action, { id: installableVersionId, installableId });
		}
	},
	async [fetchInstallableVersion.action]({ dispatch }, payload) {
		const { id: installableVersionId, installableId } = payload;
		const ret = await api.getInstallableVersion(installableId, installableVersionId);
		dispatch(setInstallableVersion.action, { data: ret });
	},
	[setInstallableVersion.action]({ commit }, payload) {
		const { data: installableVersion } = payload;
		commit(SET_INSTALLABLE_VERSION, { installableVersion });
	},
	async [installInstallableVersion.action]({ dispatch }, payload) {
		const { installableVersionId, installableId, fields } = payload;
		const ret = await api.installInstallableVersion(installableId, installableVersionId, fields);
		dispatch(selectWorkflowId.fullPath, { id: ret.id }, { root: true });
		return dispatch(getWorkflowData.fullPath, { id: ret.id, forceGet: true, forceGetNodes: true }, { root: true });
	},
};

export default actions;
